(function() {
    'use strict';

    function toggleContainerVisibility(container) {
        if (container) {
            container.classList.toggle('hidden');
        }
    }

    const footerToggleElements = document.querySelectorAll('.footer-toggle');

    footerToggleElements.forEach(function(footerToggleElement) {
        const menuContainers = [
            '.menu-footernav-container',
            '.menu-footer-kila-mobler-container',
            '.menu-footer-kundservice-container',
            '.menu-sidfot-kundservice-container',
            '.menu-sidfot-information-container',
        ];

        const textWidgets = footerToggleElement.querySelectorAll('.textwidget, .widget_media_image');
        const widgetTitles = footerToggleElement.querySelectorAll('.widgettitle');

        menuContainers.forEach(function(containerSelector) {
            const menuContainer = footerToggleElement.querySelector(
                containerSelector);
            if (menuContainer) {
                menuContainer.classList.add('hidden', 'md:block');
            }
        });

        textWidgets.forEach(function(textWidget) {
            textWidget.classList.add('menu-footer-kila-mobler-container');
            textWidget.classList.add('hidden', 'md:block');
        });

        widgetTitles.forEach(function(widgetTitle) {
            widgetTitle.addEventListener('click', function() {
                menuContainers.forEach(function(containerSelector) {
                    footerToggleElement.querySelectorAll(containerSelector).forEach(
                        toggleContainerVisibility);
                });

                // Toggle the class 'footer-toggle-open' on the parent element
                footerToggleElement.classList.toggle('footer-toggle-open');
            });
        });
    });
}());
